import { larryMediaArray } from './larryMedia'
import { larryBio } from './larryBios'
import { leonProfileReviewHinge, leonProfileReviewBumble, leonProfileReviewTinder } from './larryProfileReviews'

export const larryDatingProfileHinge = {
  _id: 'larryDatingProfileHingeId',
  userId: 'larryUserId',
  email: 'larry@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: larryMediaArray[12]._id,
      mediaItemURL: larryMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[12].type,
      caption: larryMediaArray[12].captions[0],
      subcaption: larryMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[1]._id,
      mediaItemURL: larryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[1].type,
      caption: larryMediaArray[1].captions[0],
      subcaption: larryMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[8]._id,
      mediaItemURL: larryMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[8].type,
      caption: larryMediaArray[8].captions[0],
      subcaption: larryMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[20]._id,
      mediaItemURL: larryMediaArray[20].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[20].type,
      caption: larryMediaArray[20].captions[0],
      subcaption: larryMediaArray[20].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[10]._id,
      mediaItemURL: larryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[10].type,
      caption: larryMediaArray[10].captions[0],
      subcaption: larryMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[13]._id,
      mediaItemURL: larryMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[13].type,
      caption: larryMediaArray[13].captions[0],
      subcaption: larryMediaArray[13].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: larryBio._id,
    vitalInfo: { ...larryBio.vitalInfo },
    prompts: [
      { ...larryBio.prompts[0] },
      { ...larryBio.prompts[1] },
      { ...larryBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...leonProfileReviewHinge }
  ],
  mediaItems: [ ...larryMediaArray ],
  bioItems: { ...larryBio },
}

export const larryDatingProfileBumble = {
  _id: 'larryDatingProfileBumbleId',
  userId: 'larryUserId',
  email: 'larry@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: larryMediaArray[12]._id,
      mediaItemURL: larryMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[12].type,
      caption: larryMediaArray[12].captions[0],
      subcaption: larryMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[1]._id,
      mediaItemURL: larryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[1].type,
      caption: larryMediaArray[1].captions[0],
      subcaption: larryMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[8]._id,
      mediaItemURL: larryMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[8].type,
      caption: larryMediaArray[8].captions[0],
      subcaption: larryMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[20]._id,
      mediaItemURL: larryMediaArray[20].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[20].type,
      caption: larryMediaArray[20].captions[0],
      subcaption: larryMediaArray[20].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[10]._id,
      mediaItemURL: larryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[10].type,
      caption: larryMediaArray[10].captions[0],
      subcaption: larryMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[13]._id,
      mediaItemURL: larryMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[13].type,
      caption: larryMediaArray[13].captions[0],
      subcaption: larryMediaArray[13].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: larryBio._id,
    vitalInfo: { ...larryBio.vitalInfo },
    prompts: [
      { ...larryBio.prompts[0] },
      { ...larryBio.prompts[1] },
      { ...larryBio.prompts[2] }
    ],
    aboutMe: larryBio.aboutMe[0],
    hobbies: [larryBio.hobbies[0], larryBio.hobbies[1], larryBio.hobbies[2], larryBio.hobbies[3], larryBio.hobbies[4] ],
  },
  profileReviews: [
    { ...leonProfileReviewBumble }
  ],
  mediaItems: [ ...larryMediaArray ],
  bioItems: { ...larryBio },
}

export const larryDatingProfileTinder = {
  _id: 'larryDatingProfileTinderId',
  userId: 'larryUserId',
  email: 'larry@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: larryMediaArray[12]._id,
      mediaItemURL: larryMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[12].type,
      caption: larryMediaArray[12].captions[0],
      subcaption: larryMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[1]._id,
      mediaItemURL: larryMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[1].type,
      caption: larryMediaArray[1].captions[0],
      subcaption: larryMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[8]._id,
      mediaItemURL: larryMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[8].type,
      caption: larryMediaArray[8].captions[0],
      subcaption: larryMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[20]._id,
      mediaItemURL: larryMediaArray[20].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[20].type,
      caption: larryMediaArray[20].captions[0],
      subcaption: larryMediaArray[20].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[10]._id,
      mediaItemURL: larryMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[10].type,
      caption: larryMediaArray[10].captions[0],
      subcaption: larryMediaArray[10].subcaptions[0],
    },
    {
      mediaItemId: larryMediaArray[13]._id,
      mediaItemURL: larryMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: larryMediaArray[13].type,
      caption: larryMediaArray[13].captions[0],
      subcaption: larryMediaArray[13].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: larryBio._id,
    vitalInfo: { ...larryBio.vitalInfo },
    prompts: [
      { ...larryBio.prompts[0] },
      { ...larryBio.prompts[1] },
      { ...larryBio.prompts[2] }
    ],
    aboutMe: larryBio.aboutMe[0],
    hobbies: [larryBio.hobbies[0], larryBio.hobbies[1], larryBio.hobbies[2], larryBio.hobbies[3], larryBio.hobbies[4] ],
  },
  profileReviews: [
    { ...leonProfileReviewTinder }
  ],
  mediaItems: [ ...larryMediaArray ],
  bioItems: { ...larryBio },
}